<template>
	<div class="groups-sidebar">
		<v-card-text v-if="selectedGroup" class="content">
			<v-row>
				<v-col class="center">
					<v-avatar size="120">
						<img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
					</v-avatar>
				</v-col>
				<v-col v-if="!updateName" sm="12" class="center mt-n4">
					<div class="colord-h2 font-weight-bold">
						{{ selectedGroup.name }}
						<v-icon :disabled="account.plan_id != 6" class="mb-1" color="#989898" @click="formOpen">mdi mdi-pencil</v-icon>
					</div>
				</v-col>
				<v-col v-else sm="12" class="center mt-n4">
					<div class="font-weight-bold">
						<v-form @keyup.native.enter="changeName" @submit.prevent>
							<v-text-field
								v-model="form.name"
								:error-messages="form.$errors.name"
								color="#989898"
								outlined
								dense
								dark
								@blur="form.validate('name')"
								@input="delete form.$errors.name"
							>
								<template slot="append">
									<v-icon @click="updateName = !updateName">mdi mdi-close</v-icon>
									<v-icon @click="changeName">mdi mdi-check</v-icon>
								</template>
							</v-text-field>
						</v-form>
					</div>
				</v-col>
			</v-row>
			<v-row class="mt-n1">
				<v-col class="center">
					<v-list class="aboutUser">
						<div class="titleGroup font-weight-bold colord ml-3 mb-2">GROUP MEMBERS</div>
						<v-list-item v-for="(user, index) in users" :key="index">
							<v-list-item-content>
								<v-list-item-title style="font-size: 13px; color: #989898">{{ user.user.email }}</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-switch
									:input-value="inGroup(index)"
									:disabled="account.plan_id != 6"
									class="ml-1 text-center"
									color="var(--primary)"
									inset
                                    dark
									@click="updateGroupUser(index)"
								/>
							</v-list-item-action>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="center" sm="12">
					<v-btn class="btn-alert rounded-xl" width="200px" large outlined :disabled="account.plan_id != 6" @click="deleteGroup">
						DELETE GROUP
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import * as rules from "vuelidate/lib/validators";

export default {
	name: "GroupsSidebar",
	created() {
		this.$store.dispatch("Organizations/fetchUsers");
		this.$store.dispatch("Groups/fetchGroups");
	},

	computed: {
		...mapState("User", ["account"]),
		...mapGetters("Groups", ["selectedGroup"]),
		...mapState("Organizations", ["users"]),
		...mapState("Groups", ["groups"]),
	},
	data() {
		return {
			updateName: false,
			form: new Form(this, "form", {
				name: null,
			}),
		};
	},

	validations: {
		form: {
			name: { required: rules.required },
		},
	},

	methods: {
		inGroup(index) {
			if (this.users[index].groups.find(({ id }) => id === this.selectedGroup.id)) {
				return true;
			} else return false;
		},

		updateGroupUser(index) {
			if (this.inGroup(index)) {
				this.removeUserFromGroup(index);
			} else {
				this.addUserToGroup(index);
			}
			this.$store.dispatch("Groups/fetchGroups");
		},

		addUserToGroup(index) {
			this.$store
				.dispatch("Groups/addUserToGroup", {
					group_id: this.selectedGroup.id,
					account_id: this.users[index].id,
				})
				.then(() => {
					this.$store.dispatch("Groups/fetchGroups");
					this.$store.dispatch("Organizations/fetchUsers");
				});
		},

		removeUserFromGroup(index) {
			this.$store
				.dispatch("Groups/removeUserFromGroup", {
					group_id: this.selectedGroup.id,
					account_id: this.users[index].id,
				})
				.then(() => {
					this.$store.dispatch("Groups/fetchGroups");
					this.$store.dispatch("Organizations/fetchUsers");
				});
		},

		formOpen() {
			if (!this.updateName) {
				this.updateName = !this.updateName;
			}
			this.form.name = this.selectedGroup.name;
		},

		changeName() {
			if (!this.form.validate()) {
				return;
			}
			this.$apiService.patch(`accounts/${this.account.id}/groups/${this.selectedGroup.id}`, this.form);
			this.updateName = !this.updateName;
			this.$store.dispatch("Groups/fetchGroups");
		},

		deleteGroup() {
			this.$apiService.delete(`accounts/${this.account.id}/groups/${this.selectedGroup.id}`);

			this.updatedGroups = JSON.parse(JSON.stringify(this.groups));

			this.$store.commit(
				"Groups/SET_GROUPS",
				this.updatedGroups.filter(group => group.id != this.selectedGroup.id)
			);

			this.$store.commit("Groups/SET_SELECTED_GROUP", null);
		},
	},
};
</script>

<style lang="scss">
.groups-sidebar {
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #989898;
	background: #121212;

	.content {
		width: 380px;
		background: #121212;

		.center {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.aboutUser {
			width: 730px;
			background: #121212;

			.titleGroup {
				color: #989898;
				font-size: 15px;
			}
		}

		.btn-alert {
			color: #9c0414;
		}
	}
}
</style>
